import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Copy,
  Bold,
  Row,
  Button,
  Icon,
  Spin,
  Scroll
} from "app/NativeComponents/common";

import { skipTrace } from "app/NativeActions";

import PhoneNumberMore from "./PhoneNumberMore";

class SelectToNumber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      temp_number: null,
      phone_number_more: false,
      show_options: false
    };
  }

  renderPhoneNumberLabel() {
    if (this.state.temp_number && this.state.temp_number.phone_number) {
      if (this.state.temp_number.phone_label) {
        return (
          <Copy style={{ fontSize: 10 }}>
            {this.state.temp_number.phone_label}
          </Copy>
        );
      }
    } else if (
      this.props.selected_to_number &&
      this.props.selected_to_number.phone_number
    ) {
      if (
        this.props.selected_to_number.phone_label &&
        this.props.selected_to_number.phone_label !== "Mobile" &&
        this.props.selected_to_number.phone_label !== "Landline"
      ) {
        return (
          <Copy style={{ fontSize: 10 }}>
            {this.props.selected_to_number.phone_label}
          </Copy>
        );
      }
    }
  }

  renderPhoneNumberText() {
    if (
      this.props.selected_to_number &&
      this.props.selected_to_number.phone_number
    ) {
      return this.props.selected_to_number.phone_number;
    }

    if (
      !this.props.lead_to_phone_numbers ||
      this.props.lead_to_phone_numbers.length == 0
    ) {
      if (
        this.props.active_property &&
        this.props.active_property.deal &&
        parseInt(this.props.active_property.deal.did_skip_trace) !== 1
      ) {
        if (
          this.props.active_property.deal.updating &&
          this.props.active_property.deal.updating.is_updating &&
          (this.props.active_property.deal.updating.updating_type ==
            "skip_trace_leads_v2" ||
            this.props.active_property.deal.updating.updating_type ==
              "skip_trace_leads" ||
            this.props.active_property.deal.updating.updating_type ==
              "skip_trace_lead" ||
            this.props.active_property.deal.updating.updating_type ==
              "skip_trace")
        ) {
          return "Skip Tracing...";
        } else {
          return "Skip Trace Lead";
        }
      }
      return "No Numbers Available";
    }

    return "Select a Number";
  }

  renderNumberLabel(phone_number) {
    let number = phone_number;

    if (number) {
      let label_color = this.props.colors.success_color;
      let label_text = "";
      let label_text_color = this.props.colors.white_text_color;
      if (number.blocked == 1) {
        label_color = this.props.colors.error_color;
        label_text = "Blocked";
      } else if (number.is_litigator == 1) {
        label_color = this.props.colors.error_color;
        label_text = "Known Litigator";
      } else if (number.do_not_call == 1) {
        label_color = this.props.colors.error_color;
        label_text = "Do Not Call";
      } else if (number.landline == 1) {
        label_color = this.props.colors.background_color;
        label_text = "Landline";
        label_text_color = this.props.colors.text_color;
      } else if (number.bad_phone == 1) {
        label_color = this.props.colors.error_color;
        label_text = "Wrong Number";
      } else if (number.expected_undeliverable) {
        label_color = this.props.colors.background_color;
        label_text = "Undeliverable";
        label_text_color = this.props.colors.text_color;
      }
      if (!!label_text) {
        return (
          <Wrapper
            style={{
              padding: 3,
              borderRadius: 20,
              paddingLeft: 10,
              paddingRight: 10,
              marginRight: 10,
              backgroundColor: label_color
            }}
          >
            <Copy
              style={{
                color: label_text_color,
                fontSize: 10
              }}
            >
              <Bold>{label_text}</Bold>
            </Copy>
          </Wrapper>
        );
      }
    }
  }

  renderOptions() {
    if (this.state.show_options) {
      return (
        <Scroll
          style={{
            maxHeight: 200
          }}
        >
          {this.props.lead_to_phone_numbers.map((phone_number, i) => {
            return (
              <Button
                key={i}
                style={{
                  height: 50,
                  alignItems: "flex-start",
                  justifyContent: "center"
                }}
                onPress={() => {
                  this.props.updateSelectedToPhoneNumber(phone_number);
                  this.setState({
                    show_options: false
                  });
                }}
              >
                <Row
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: 5,
                    paddingLeft: 5
                  }}
                >
                  <Icon
                    style={{
                      width: 30,
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                    icon={
                      this.props.selected_to_number &&
                      phone_number.owner_phone_number_id ==
                        this.props.selected_to_number.owner_phone_number_id
                        ? "radio-button-checked"
                        : "radio-button-unchecked"
                    }
                  />
                  <Row>
                    <Wrapper style={{ marginRight: 10 }}>
                      <Copy>
                        <Bold>{phone_number.phone_number}</Bold>
                      </Copy>
                      {phone_number.phone_label &&
                      phone_number.phone_label !== "Mobile" &&
                      phone_number.phone_label !== "Landline" ? (
                        <Copy>{phone_number.phone_label}</Copy>
                      ) : null}
                    </Wrapper>
                    {this.renderNumberLabel(phone_number)}
                  </Row>
                </Row>
              </Button>
            );
          })}
        </Scroll>
      );
    }

    return (
      <Button
        style={{
          height: 50,
          alignItems: "flex-start",
          justifyContent: "center"
        }}
        onPress={() => {
          if (
            this.props.lead_to_phone_numbers &&
            this.props.lead_to_phone_numbers.length > 0
          ) {
            this.setState({
              show_options: !this.state.show_options
            });
          } else {
            if (
              this.props.active_property &&
              this.props.active_property.deal &&
              parseInt(this.props.active_property.deal.did_skip_trace) !== 1 &&
              (!this.props.active_property.deal.updating ||
                !this.props.active_property.deal.updating.is_updating ||
                (this.props.active_property.deal.updating.updating_type !==
                  "skip_trace_leads_v2" &&
                  this.props.active_property.deal.updating.updating_type !==
                    "skip_trace_leads" &&
                  this.props.active_property.deal.updating.updating_type !==
                    "skip_trace_lead" &&
                  this.props.active_property.deal.updating.updating_type !==
                    "skip_trace"))
            ) {
              this.props.setModal({
                title: "There are no phone numbers for this lead.",
                description:
                  "You can add phone numbers to this lead manually, or skip trace it to lookup phone numbers for the property owner.",
                submit: "Skip Trace Lead",
                onPress: () => {
                  skipTrace({
                    props: this.props,
                    properties: [this.props.active_property],
                    total_property_count: 1,
                    onSuccess: () => {}
                  });
                },
                cancel: "Not right now.",
                onCancel: () => {}
              });
              this.props.toggleModal({ show: true, type: "normal" });
            }
          }
        }}
      >
        <Row style={{ padding: 10 }}>
          <Wrapper style={{ marginRight: 10 }}>
            <Copy>
              <Bold>{this.renderPhoneNumberText()}</Bold>
            </Copy>
            {this.renderPhoneNumberLabel()}
          </Wrapper>
          {this.renderNumberLabel(this.props.selected_to_number)}
          <Icon
            fa_icon="sort"
            size={14}
            color={this.props.colors.light_gray_color}
          />
        </Row>
      </Button>
    );
  }

  render() {
    if (this.props.lead_conversations_loading) {
      return (
        <Wrapper style={{ paddingLeft: 15, paddingRight: 15 }}>
          <Row style={{ marginBottom: 5 }}>
            <Copy style={{ width: 40 }}>To:</Copy>
            <Wrapper>
              <Wrapper
                style={{
                  height: 50,
                  margin: 10,
                  marginBottom: 0,
                  marginTop: 0,
                  borderRadius: 5,
                  borderColor: this.props.colors.border_color,
                  borderWidth: 1,
                  borderStyle: "solid",
                  backgroundColor: this.props.colors.card_color,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Row style={{ paddingLeft: 10, paddingRight: 10 }}>
                  <Spin size="small" />
                  <Copy style={{ marginLeft: 5 }}>Loading Numbers</Copy>
                </Row>
              </Wrapper>
            </Wrapper>
          </Row>
        </Wrapper>
      );
    }

    return (
      <Wrapper style={{ paddingLeft: 15, paddingRight: 15 }}>
        <Row style={{ marginBottom: 5, alignItems: "flex-start" }}>
          <Wrapper
            style={{
              width: 40,
              height: 50,
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Copy>To:</Copy>
          </Wrapper>

          <Wrapper>
            <Wrapper
              style={{
                margin: 10,
                marginBottom: 0,
                marginTop: 0,
                borderRadius: 5,
                borderColor: this.props.colors.border_color,
                borderWidth: 1,
                borderStyle: "solid",
                backgroundColor: this.props.colors.card_color
              }}
            >
              {this.renderOptions()}
            </Wrapper>
          </Wrapper>
        </Row>
      </Wrapper>
    );
  }
}

export default SelectToNumber;
